import React, { FunctionComponent } from 'react';

import {
  $StepsOrchestratorAnimation,
  $StepsOrchestratorContainer,
} from './StepsOrchestrator.styles';

interface StepsOrchestratorAnimationProps {
  parentPadding: number;
}

const StepsOrchestratorAnimation: FunctionComponent<
  React.PropsWithChildren<StepsOrchestratorAnimationProps>
> = ({ children, parentPadding }) => {
  return (
    <$StepsOrchestratorContainer
      $parentPadding={parentPadding}
      data-testid="StepsOrchestratorContainer"
    >
      <$StepsOrchestratorAnimation $parentPadding={parentPadding}>
        {children}
      </$StepsOrchestratorAnimation>
    </$StepsOrchestratorContainer>
  );
};

export default StepsOrchestratorAnimation;
